export default {
    name: 'Star',
    dimensions: { width: 20, height: 21 },
    content: `<path fill="none" stroke="currentColor" d="M7 7.5L10 1.5L13 7.5L19 8.5L14.5 13.5L16.0204 19.5L10 16.5L4.10184 19.5L5.5 13.5L1 8.5L7 7.5Z" stroke-width="2" stroke-linejoin="round"/>`
};
